import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {
    ac: any
    constructor(private router: Router, private activateRouter: ActivatedRoute) {
        this.activateRouter.queryParamMap.subscribe((params) => {
            console.log("params", params)
            this.ac = params.get("ac");
            console.log(this.ac);
        })
        console.log(this.router.url);
    }

    canActivate() {
        // return true;
        if (localStorage.getItem('api_key')) {
            return true;
        }
        // if (this.ac != "" && this.ac != null) {
        if (this.ac != "" && this.ac != "null" && this.ac != null) {
            this.router.navigate(['/login'], { queryParams: { ac: this.ac } });
        } else {
            this.router.navigate(['/login']);
        }
        return false;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2455195120/src/src/app/shared/guard/auth.guard.ts